import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { dataModel, Industry, Premium } from '../../models/data.model';
import { of, Observable} from 'rxjs';
import { environment } from '../../../environments/environment';
import { forkJoin } from 'rxjs';

import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
// tslint:disable: max-line-length
// tslint:disable: prefer-const
// tslint:disable: object-literal-shorthand
// tslint:disable: object-literal-key-quotes
// tslint:disable: prefer-for-of
// tslint:disable: curly
// tslint:disable: variable-name

export class CouchdbService {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService) {}

  getObservable(): Observable<any> {
    return of(this.structured());
  }

  document(url: string): Observable < any > {
    return this.http.get(url);
  }

  premium(pageTitle: any, premiumCaseStudies: any, routingTitle: string, id: any) {
    let _inner = new Industry(pageTitle, premiumCaseStudies, routingTitle, id);
    const type: Premium = { [pageTitle]: _inner };
    let tempRouter = [];

    _inner.data.forEach(el => {
      tempRouter.push(el.CompanyName.replace(/[^A-Z0-9]/ig, '-').toLowerCase());
      el.router = this.find_duplicate_in_array(tempRouter) ? el.CompanyName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() + '-2' : el.CompanyName.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
      el.id = id;
      el.videoURL = premiumCaseStudies.length !== 0 && el.CompanyType !== null ? 'https://player.vimeo.com/video/' + el.CompanyType : '';
      el.CastStudyType = el.router;
    });

    if (_inner.name === pageTitle) {
      return type[_inner.name];
    }
  }

  find_duplicate_in_array(arr: any) {
    for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
                if (arr[i] === arr[j]) {
                    return true;
                }
        }
    }
    return false;
  }

  getMultipleDocuments(arr: Array < any > ): Observable < any > {
    let temp: Array < any > = [];
    for (let i = 0; i < arr.length; i++)
      temp.push(this.http.get(arr[i]));
    return forkJoin(temp);
  }
// this.authenticationService.currentUserValue
  verifyDocuments(_verifyData: any, data: Array < any > ) {
    for (let i = 0; i < data.length; i++) {
      // if (data[i].ExampleOnlineCaseStudy !== undefined && data[i].sectorName) {

      //   _verifyData.ExampleOnlineCaseStudy.push((data[i].sectorName, data[i].ExampleOnlineCaseStudy, data[i].routingTitle, data[i].Id));
      //  }
      if (data[i].fullCaseStudies !== undefined && data[i].sectorName) {

       _verifyData.PremiumIndustries.push(this.premium(data[i].sectorName, data[i].fullCaseStudies,  data[i].routingTitle, data[i].Id));
      
    }
           if (data[i].ExampleOnlineCaseStudy !== undefined && data[i].sectorName) {
            _verifyData.industries.push({
              titles: data[i].sectorName,
              routers: data[i].routingTitle,
              videos: 'https://player.vimeo.com/video/' + data[i].sectorvideolink,
              logo: environment.assetsURL + data[i].Id + '/' + data[i].sectorlogo,
              coverImage: environment.assetsURL + data[i].Id + '/' + data[i].onlineCoverImage,
              coverQuote: data[i].coverQuote,
              quoteAuthor: data[i].quoteAuthor,
              quoteCompany: data[i].quoteCompany,
              caseStudies: data[i].casestudytasters,
              example: data[i].ExampleOnlineCaseStudy[0],
              ids: data[i]._id,
              assetId: data[i].Id
            });
  }
   else   if (data[i].sectorName) {
        _verifyData.industries.push({
          titles: data[i].sectorName,
          routers: data[i].routingTitle,
          videos: 'https://player.vimeo.com/video/' + data[i].sectorvideolink,
          logo: environment.assetsURL + data[i].Id + '/' + data[i].sectorlogo,
          coverImage: environment.assetsURL + data[i].Id + '/' + data[i].onlineCoverImage,
          coverQuote: data[i].coverQuote,
          quoteAuthor: data[i].quoteAuthor,
          quoteCompany: data[i].quoteCompany,
          caseStudies: data[i].casestudytasters,
          example: undefined,
          ids: data[i]._id,
          assetId: data[i].Id

        });
      } else {
        _verifyData.title = data[i].homePageTitle;
        _verifyData.title1 = data[i].TitleOnlineEvents;
        _verifyData.navi1 = data[i].TitileLinkA;
        _verifyData.navi2 = data[i].TitileLinkB;
        _verifyData.navi3 = data[i].TitileLinkC;
        _verifyData.logo = environment.assetsURL + data[i].Id + '/' + data[i].siteLogo;
        //_verifyData.coverQuote = data[i].coverQuote;
        _verifyData.loginTitle = data[i].loginTitle;
        _verifyData.loginSubtitle = data[i].loginSubtext;
        _verifyData.socialMedia.push({
          'url': data[i].SocialURLLinkedin,
          'name': 'linkedin'
        });
        _verifyData.socialMedia.push({
          'url': data[i].SocialURLTwitter,
          'name': 'twitter'
        });
        _verifyData.socialMedia.push({
          'url': data[i].SocialURLYoutube,
          'name': 'youtube'
        });
        _verifyData.socialMedia.push({
          'url': data[i].SocialURLVimeo,
          'name': 'vimeo'
        });
        _verifyData.thankYouTitle = data[i].thankYouTitle;
        _verifyData.thankYouMessage = data[i].thankYouMessage;
        _verifyData.FooterCopyrights = data[i].FooterCopyrights;
        _verifyData.error404Title = data[i].error404Title;
        _verifyData.error404Message = data[i].error404Message;
        _verifyData.error404btn = data[i].error404btn;
        _verifyData.contactEmail = data[i].contactEmail;
        _verifyData.popUPemail = data[i].popUPemail;
        _verifyData.requestAccess = data[i].textRequestAccess;
        _verifyData.checkBoxText = data[i].checkboxForGdpr;
        _verifyData.textGDPR = data[i].textGDPR;
      }
    }
    return _verifyData;
  }

  structured() {
    let _data = new dataModel();
    this.document(environment.apiForLogin).subscribe(api => {
      let arrTemp = api.industrysectorlist.map((a: {
        Tag: string;
      }) => environment.doc + a.Tag);
      this.getMultipleDocuments(arrTemp).subscribe(el => {
        this.verifyDocuments(_data, el);
      });
    });
    return _data;
  }
}
